<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-primary shape-skew alpha-4" style="background-image: linear-gradient(to bottom right, black, #0C7395);">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center ">
                            <div class="col-lg-3 order-lg-2 ">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="photo" class="rounded-circle img-center img-fluid shadow shadow-lg--hover">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <div class="card-profile-actions py-4 mt-lg-0">
                                    <base-button tag="a" :href="this.$store.state.artist[this.index].insta" type="default" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" :href="this.$store.state.artist[this.index].apple" type="default" icon="fa fa-music" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" :href="this.$store.state.artist[this.index].spotify" type="default" icon="fa fa-spotify" rounded
                                                 icon-only></base-button>
								    <base-button v-if="this.$store.state.artist[this.index].name == 'Impak'" tag="a" :href="this.$store.state.artist[this.index].youtube" type="default" icon="fa fa-youtube" rounded
                                                 icon-only></base-button>	
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-1">
    
                            </div>
                        </div>
                        <div class="text-center mt-5 pt-3">
                            <h3>{{this.$store.state.artist[this.index].name}}
                            </h3>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p>{{this.$store.state.artist[this.index].bio}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {
  props: ['profile'],
  data() {
    return {
      index: 0,
	  photo: '',
    };
  },
  beforeMount() {
    // Example action: fetch user profile data based on the 'name' prop
	  
	this.index = this.$store.state.artist.findIndex(obj => obj.name.toLowerCase() === this.profile.toLowerCase());
	  if (this.index == -1) this.index = 0
	this.photo = '/' + this.$store.state.artist[this.index].photo
	//   console.log(this.photo)
  },
};
</script>
<style>
</style>
